// extracted by mini-css-extract-plugin
export default {"link":"orderInfo_link__8LY-r"};